import styled from 'styled-components/native';
import VideoPlayer from 'react-native-video-controls';
import Feather from 'react-native-vector-icons/Feather';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.TouchableOpacity`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #000;
`;

export const VideoContainer = styled(VideoPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  right: 24px;
  top: ${RFPercentage(8)}px;
  z-index: 2;
`;
export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const ControlIcon = styled(Ionicons)`
  font-size: ${RFValue(32)}px;
  z-index: 2;
  color: ${({theme}) => theme.colors.shape};
`;
